// extracted by mini-css-extract-plugin
export default {"card__list":"Deck_card__list__M8L03","card__container":"Deck_card__container__Pd94X","card__img":"Deck_card__img__zsSy8"};